// extracted by mini-css-extract-plugin
export default {"root":"GrpNav_root__cIrp+","container":"GrpNav_container__KSSVI","right-pane":"GrpNav_right-pane__W6aMD","item":"GrpNav_item__3Ibs4"};